import { render, staticRenderFns } from "./detailBaseInfo.vue?vue&type=template&id=471f7e86"
import script from "./detailBaseInfo.vue?vue&type=script&lang=js"
export * from "./detailBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./detailBaseInfo.vue?vue&type=style&index=0&id=471f7e86&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports